import { IS_PRODUCTION } from '../utils/envUtils'

export enum RecurringFrequencyType {
  Weekly = 'Weekly',
  BiWeekly = 'Bi-Weekly',
  Monthly = 'Monthly',
  FiveMinutely = 'Five-Minutely'
}

const excludedValue = 'Five-Minutely'

export const RECURRING_FREQUENCY_SELECT_OPTIONS = Object.values(RecurringFrequencyType)
  .filter(value => !(IS_PRODUCTION && value === excludedValue)) // Exclude 'Five-Minutely' only if IS_PRODUCTION is true
  .map(value => ({ label: value, value }))
